import { lazy, Suspense } from 'react';
import { Outlet, createRoute } from '@tanstack/react-router';

import DashboardLayout from 'src/layouts/dashboard';

import AppAuthGuard from 'src/components/auth/app-auth-guard';
import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import { rootRoute } from './root';

const Profile = lazy(() => import('src/sections/user/view'));
const ChangePassword = lazy(() => import('src/sections/change-password/view'));

// User routes
const userRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'user',
  component: () => (
    <AppAuthGuard splashScreen={<SplashScreen />}>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </AppAuthGuard>
  ),
});

const userIndexRoute = createRoute({
  getParentRoute: () => userRoute,
  path: '/',
  component: Profile,
});

const changePasswordRoute = createRoute({
  getParentRoute: () => userRoute,
  path: 'change-password',
  component: ChangePassword,
});

export const userRouteTree = userRoute.addChildren([userIndexRoute, changePasswordRoute]);
